import { withInstall } from '@sgui-plus/utils/with-install'
import Statistic from './src/statistic.vue'

export const SgStatistic = withInstall(Statistic)

export default SgStatistic
export * from './src/statistic'
